import { Component} from 'react'

import Header from '../Home/Header'
import Footer from '../Home/Footer'

import PhotoItems from './photoItems'

class PhotosJours extends Component {
  constructor() {
    super()
    this.state = {justDate: ""}
    this.state = {justDay: ""}
    this.state = {renderList: []}
    
  }
  componentDidMount() {
    const justDate = parseInt(((window.location.pathname).split('/')[2]))
    this.setState({justDate});
    const justDay = ((window.location.pathname).split('/')[3])
    this.setState({justDay});

    function rightDateDay(element) {
      if (element.date === justDate && element.jour === justDay) {
        return true
      } else {
        return false
      }
    }
    
    
   let renderList = PhotoItems.filter(rightDateDay) 
   this.setState({renderList})
    
  }
  render() {
    return (
      <div className='core'>
        <Header />
 <h2 className='titre bloc'>Photos {this.state.justDate} {this.state.justDay}</h2>
        <div className='bloc bloc__photo'>
          {this.state.renderList.map((val) => {
      let id = val.id
      let url = val.url
      let lienImage = "/galerie/:" + (id)
      return (
        <div key={id}>
          <a href={lienImage}>
            <img className='photo' alt='Photo Cortege' src={url}></img>
          </a>
        </div>
      )
    })}
        </div>
        <Footer />
      </div>
  
    )
  }
  }
   

export default PhotosJours